import InputField from "../../../components/InputField";
import Toggle from "../../../components/Toggle";
import TextareaField from "../../../components/TextareaField";

export default function ServiciiStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Numar contract" value={data.numarContract} onChange={update("numarContract")} placeholder="ex: PS-2026-001" half helperText="Optional — poti completa de mana pe document" />

      <TextareaField
        label="Obiectul contractului (descrierea serviciilor)"
        value={data.obiectContract}
        onChange={update("obiectContract")}
        placeholder="Descrieti serviciile care fac obiectul contractului, cat mai detaliat..."
        required
        error={errors.obiectContract}
        rows={5}
      />

      <div style={{ width: "100%" }}>
        <Toggle
          label="Durata nedeterminata"
          description="Contractul nu are o data de sfarsit stabilita"
          checked={!!data.durataNedeterminata}
          onChange={() => update("durataNedeterminata")(!data.durataNedeterminata)}
        />
      </div>

      {!data.durataNedeterminata && (
        <>
          <InputField label="Data inceput" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
          <InputField label="Data sfarsit" value={data.dataSfarsit} onChange={update("dataSfarsit")} type="date" required half error={errors.dataSfarsit} />
        </>
      )}

      {data.durataNedeterminata && (
        <InputField label="Data inceput" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
      )}
    </div>
  );
}
